import { LayoutOptions } from "../helpers/prop-types-helper";

export const SliderOptions = {
  sliderAutoplay: LayoutOptions.Boolean,
  sliderAutoplayDelay: LayoutOptions.Range(1000, 6000, 1000),
  sliderAutoplayLimit: LayoutOptions.Range(0, 21),
  sliderHideArrows: LayoutOptions.Boolean,
  sliderDisableSwiping: LayoutOptions.Boolean,
  sliderNavigationSpace: LayoutOptions.Range(1, 11),
  sliderTransitionSpeed: LayoutOptions.Range(100, 1100, 100),
  sliderInfiniteLooping: LayoutOptions.Boolean,
};
